import { render, staticRenderFns } from "./RulesOfPackage.vue?vue&type=template&id=05e77a95&"
import script from "./RulesOfPackage.vue?vue&type=script&lang=js&"
export * from "./RulesOfPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports